export default "__VITE_ASSET__CNzIsKm4__"